import { Locale } from '@core/types/base';
import { CountryIsoCode } from '@core/types/country';

export function getCountryIsoCode(locale: Locale): CountryIsoCode {
  return locale.split('_')[1] as CountryIsoCode;
}
